function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .clsdd0-1,.clsdd0-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.7px}.clsdd0-1{stroke:#1b1464}.clsdd0-2{stroke:#d53d53}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "2697-wWallet_icon",
  transform: "translate(9159.85 6486.099)"
}, /*#__PURE__*/React.createElement("path", {
  id: "2697-wPath_23909",
  d: "M22.583 11H16.9a1.866 1.866 0 0 0-1.9 1.9",
  className: "clsdd0-1",
  transform: "translate(-9174 -6491.193)"
}), /*#__PURE__*/React.createElement("path", {
  id: "2697-wPath_23910",
  d: "M48.687 14.791V11H43",
  className: "clsdd0-1",
  transform: "translate(-9184.307 -6491.193)"
}), /*#__PURE__*/React.createElement("path", {
  id: "2697-wPath_23911",
  d: "M38.694 11.847L29.847 3 21 11.847",
  className: "clsdd0-2",
  transform: "translate(-9176.209 -6488.249)"
}), /*#__PURE__*/React.createElement("path", {
  id: "2697-wPath_23912",
  d: "M36.843 15.2l-3.077-3.1a1.673 1.673 0 0 1-2.679 0l-3.1 3.1",
  className: "clsdd0-2",
  transform: "translate(-9178.781 -6491.598)"
}), /*#__PURE__*/React.createElement("path", {
  id: "2697-wPath_23913",
  d: "M41.54 27.9v5.055H16.9a1.866 1.866 0 0 1-1.9-1.9V14a1.866 1.866 0 0 0 1.9 1.9h24.64v4.423",
  className: "clsdd0-1",
  transform: "translate(-9174 -6492.297)"
}), /*#__PURE__*/React.createElement("path", {
  id: "2697-wPath_23914",
  d: "M43.16 25.264a3.16 3.16 0 1 0 0 6.319h6.951A1.966 1.966 0 0 0 52 29.814c-.012.16 0 .019 0-.127v-5.055a.634.634 0 0 0-.626-.632h-.632a1.374 1.374 0 0 1-1.264 1.264H43.16",
  className: "clsdd0-1",
  transform: "translate(-9183.202 -6495.978)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "2697-wEllipse_655",
  cx: 0.951,
  cy: 0.951,
  r: 0.951,
  fill: "#d53d53",
  transform: "rotate(-45 -12376.936 7800.383)"
}));

var SvgHWallet = function SvgHWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.504,
    height: 27.609,
    viewBox: "0 0 29.504 27.609",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-wallet.6c9fbcc8.svg";
export { ForwardRef as ReactComponent };